import { render, staticRenderFns } from "./SwiperPaginationContainer.vue?vue&type=template&id=51263ec2&"
import script from "./SwiperPaginationContainer.vue?vue&type=script&lang=js&"
export * from "./SwiperPaginationContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports